<div
  class="upload-box"
  [class.upload-drag]="hasFile()"
>
  <div class="step-title small">
    <span class="step-number">3</span>
    <h3>{{ 'uploadFile' | translate }}</h3>
  </div>
  <input
    #fileInput
    type="file"
    accept=".csv"
    hidden
    id="fileInput"
    (change)="onFileUpload($event)"
  />
  <div
    class="drag-area"
    role="button"
    [tabindex]="isDisabled() ? -1 : 0"
    [attr.aria-disabled]="isDisabled()"
    (click)="openFilePicker()"
    (keydown)="onDragAreaKeydown($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    [class.drag-over]="isDragging()"
    [class.is-disabled]="isDisabled()"
    [class.has-file]="hasFile()"
  >
    <i class="pi pi-cloud-upload"></i>
    <p class="text-info-csv">{{ 'dragCsvHere' | translate }}</p>
    <span class="click-here">{{ 'orClickToSelect' | translate }}</span>
    <span class="file-limit">{{ 'fileLimit' | translate }}</span>
    @if (!hasFile()) {
      <div class="csv-warning">
        <p class="text">
          Guardar como <strong> CSV </strong> antes de subirlo.
        </p>
      </div>
    }
  </div>
  @if (hasFile()) {
    <div class="selected-file-item">
      <i class="pi pi-file"></i>
      <div class="file-name-container">
        <span class="selected-file-name" [title]="fileName() ?? ''">
          {{ fileName() }}
        </span>
        <span class="file-size"> ({{ fileSizeMB() }}) </span>
      </div>
      <button
        type="button"
        class="remove-file-button"
        (click)="onRemoveFile()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  }
  <div class="submit-container">
    <app-button
      [data]="{
        id: 'upload-riesgos',
        label: 'Cargar Archivo',
        icon: 'pi-cloud-upload'
      }"
      [disabled]="isUploadDisabled()"
      (click)="upload.emit()"
    ></app-button>
  </div>
</div>
